<template>
  <button type="button" class="icon-button" :style="compStyles" @click="click">
    <div class="icon-button-content">
      <div class="icon-box">
        <inline-svg :src="icon" class="button-icon" :width="'20px'" :height="'20px'" :fill="'white'" :stroke="'none'" />
      </div>

      <slot />
    </div>
  </button>
</template>

<script>
export default {
  name: 'icon-button',

  inheritAttrs: false,

  props: {
    color: {
      type: String,
      default: '#fff',
    },
    bgColor: {
      type: String,
      default: '#333',
    },
    width: {
      type: String,
      default: '136px',
    },
    svg: {
      type: String,
      default: null,
    },
  },

  computed: {
    icon() {
      return this.svg || this.$assets.svg.arrowIcon;
    },
    compStyles() {
      return {
        width: this.width,
        color: this.color,
        background: this.bgColor,
      };
    },
  },

  methods: {
    click() {
      this.$emit('click');
    },
  },
};
</script>

<style scoped>
.icon-button {
  height: 2.5em;
  font-size: 1em;

  background: #f17901;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
  border: none;
  border-radius: 0.4em;

  cursor: pointer;
}

.icon-button-content {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  position: relative;
  width: 100%;

  font-family: Helvetica;
  font-size: 1em;
}

.icon-button-content .icon-box {
  display: flex;
  align-items: center;
  right: 0;
  margin-right: 0.5em;
  width: 1.5em;
  height: 1.5em;
}
</style>
